
import React, { useState, useRef, useEffect } from "react";
import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  isDisabled = false, // ✅ New prop
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (selected && Array.isArray(options)) {
      const found = options.find((option) => option.id === selected);
      if (found) {
        setSelectedLabel(found.label);
      } else {
        setSelectedLabel("");
      }
    }
  }, [selected, options]);

  const handleClick = (option) => {
    if (isDisabled) return; // 🔒 Prevent changes if disabled
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  return (
    <div
      className={`dropdown-CB ${className || ""}`}
      style={{
        width,
        ...style,
        pointerEvents: isDisabled ? "none" : "auto",
        opacity: isDisabled ? 0.7 : 1,
      }}
      ref={dropdownRef}
    >
      <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className="dropdown-btn"
        onClick={() => {
          if (!isDisabled) setIsActive(!isActive);
        }}
        style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
      >
        {selectedLabel || "Select..."}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{ width: customWidth, top: customTop }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item-CBV2"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
